var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "modal-indexes" } }, [
    _c("h3", { staticClass: "title-modal" }, [_vm._v("Delete Index")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "wrap-otp" }, [
      _c("label", [_vm._v("OTP CODE")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-otp-wrap" },
        _vm._l(Object.keys(_vm.otpData), function(otp, index) {
          return _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.otpData[otp],
                expression: "otpData[otp]"
              }
            ],
            key: otp,
            ref: "inputOtpRef" + index,
            refInFor: true,
            staticClass: "otp",
            attrs: {
              "tab-index": index,
              disabled: _vm.isDisabledInputOtp,
              type: "text",
              maxlength: "1",
              onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
            },
            domProps: { value: _vm.otpData[otp] },
            on: {
              keyup: _vm.handleInput,
              paste: _vm.handlePaste,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.otpData, otp, $event.target.value)
              }
            }
          })
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column align-items-end mt-2" }, [
        !_vm.isRequestOTP
          ? _c(
              "p",
              { staticClass: "request-otp", on: { click: _vm.requestOTP } },
              [_vm._v("\n        Request OTP\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isRequestOTP && _vm.isExpired
          ? _c("p", { staticClass: "text-valid-otp" }, [
              _vm._v("\n        The code has expired, "),
              _c("span", { on: { click: _vm.requestOTP } }, [
                _vm._v("Resend a new code")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isRequestOTP && !_vm.isExpired
          ? _c("p", { staticClass: "text-valid-otp" }, [
              _vm._v(
                "\n        Code is valid for " +
                  _vm._s(_vm.timerExpired) +
                  " minutes\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isRequestOTP && !_vm.isExpired
          ? _c("div", { staticClass: "didnt-get-otp" }, [
              _vm._v("\n        Didn’t receive code?\n        "),
              _c(
                "span",
                {
                  style: {
                    opacity: _vm.timerCountReqNewOtp > 0 ? 0.6 : 1,
                    cursor:
                      _vm.timerCountReqNewOtp > 0 ? "not-allowed" : "pointer"
                  },
                  on: { click: _vm.requestOTP }
                },
                [_vm._v("\n          Resend a new code\n        ")]
              ),
              _vm._v(" "),
              _vm.timerCountReqNewOtp > 0
                ? _c(
                    "span",
                    {
                      style: {
                        opacity: _vm.timerCountReqNewOtp > 0 ? 0.6 : 1,
                        cursor:
                          _vm.timerCountReqNewOtp > 0
                            ? "not-allowed"
                            : "pointer"
                      }
                    },
                    [
                      _vm._v(
                        "\n          (" +
                          _vm._s(_vm.timerCountReqNewOtp) +
                          "s)\n        "
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-end mt-4" },
      [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button-red",
            attrs: { disabled: !_vm.isFilledOtp },
            on: { click: _vm.deleteIndexes }
          },
          [_vm._v("\n      Delete\n    ")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/icon/info.svg"),
          alt: "information-icon"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c("p", { staticClass: "information-title" }, [_vm._v("Information")]),
        _vm._v(" "),
        _c("p", { staticClass: "information-desc" }, [
          _vm._v(
            "\n        Please confirm delete index with OTP code from your email.\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fe29422", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe29422","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/partials/modalDeleteIndexes.vue
// module id = null
// module chunks = 